import o, { useRef as c, useEffect as m } from "react";
import d from "react-slick";
import s from "gsap";
import p from "classnames";
import u from "../../../../../_virtual/splitText.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
/* empty css                 */
import f from "./rotativeText.module.scss.js";
function A({
  texts: l
}) {
  const t = c(null), n = {
    autoplay: l.length > 1,
    infinite: l.length > 1,
    arrows: !1,
    dots: !1,
    autoplaySpeed: 4e3,
    speed: 1200,
    draggable: !1,
    fade: !0,
    adaptiveHeight: !1,
    beforeChange(r, e) {
      const i = [...t.current.querySelectorAll(`.slider__item--${e} .char`)];
      i.length > 0 && s.set(i, { x: "0.5rem", opacity: 1e-4 }), t.current.querySelectorAll(`.slider__item--${r} .line`).forEach((a) => {
        s.to(a.querySelectorAll(".char"), {
          x: "-0.5rem",
          duration: 0.6,
          ease: "power4.inOut",
          opacity: 1e-4,
          stagger: 0.05
        });
      }), t.current.querySelectorAll(`.slider__item--${e} .line`).forEach((a) => {
        s.to(a.querySelectorAll(".char"), {
          x: "0%",
          duration: 0.6,
          ease: "power4.inOut",
          opacity: 1,
          stagger: 0.05,
          delay: 0.6
        });
      });
    }
  };
  return m(() => {
    [...t.current.querySelectorAll(".slider__item")].map((e) => new u(e, {
      type: "lines, words, chars",
      linesClass: "line line--++",
      wordsClass: "word word--++",
      charsClass: "notranslate char char--++"
    }));
  }, []), /* @__PURE__ */ o.createElement("div", { ref: t, "data-testid": "rotative-text", className: "rotative-text" }, /* @__PURE__ */ o.createElement(d, { ...n }, l.map((r, e) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ o.createElement(
      "div",
      {
        className: p(`slider__item slider__item--${e}`, f.text),
        key: e,
        dangerouslySetInnerHTML: {
          __html: r
        }
      }
    )
  ))));
}
export {
  A as RotativeText
};
//# sourceMappingURL=RotativeText.js.map
